import { BrowserAuthError, BrowserAuthErrorCodes } from "@azure/msal-browser";

// MSAL rejects 30s after window.location.assign when the page is still alive; the navigation itself was already handed to the browser.
export function isRedirectNavigationTimeout(error: unknown): boolean {
  return (
    error instanceof BrowserAuthError &&
    error.errorCode === BrowserAuthErrorCodes.timedOut &&
    error.subError === "failed_to_redirect"
  );
}
